import {
  computeBoltOnDischargeLabel,
  isBoltOnDischargeMeasurementKnown
} from "@/models/equipment/bolt_on_discharges/properties";
import { LengthUnits } from "@/libs/units/length";
import { computed } from "vue";
import type { RenderScenarioExportCols } from "./sizingExportTypes";

/**
 * The HPS catalog ships without length, weight and outer diameter, and an
 * administrator adds them later. The calculations read a missing measurement as
 * zero, because the arithmetic needs a number. The export must not repeat that
 * zero, because a zero in a spreadsheet cell reads as a measurement. These
 * cells stay empty until the catalog holds the value.
 */
export const renderBoltOnDischargeCols: RenderScenarioExportCols = ({
  scenario,
  calcs,
  targetUnits
}) => [
  {
    section: "BOLT ON DISCHARGE",
    label: "Manufacturer Series/Model",
    targetUnit: null,
    value: computeBoltOnDischargeLabel(
      scenario.equipment.value?.r_bolt_on_discharge
    )
  },
  {
    section: "BOLT ON DISCHARGE",
    label: "OD",
    targetUnit: LengthUnits.Inches,
    value: scenario.equipment.value?.r_bolt_on_discharge?.outer_diameter_inches,
    disableConversion: true
  },
  {
    section: "BOLT ON DISCHARGE",
    label: "Flange OD",
    targetUnit: LengthUnits.Inches,
    value:
      scenario.equipment.value?.r_bolt_on_discharge
        ?.flange_outer_diameter_inches,
    disableConversion: true
  },
  {
    section: "BOLT ON DISCHARGE",
    label: "Length",
    targetUnit: targetUnits.largeLengthUnit,
    value: computed(() =>
      isBoltOnDischargeMeasurementKnown(
        scenario.equipment.value?.r_bolt_on_discharge?.length_inches
      )
        ? calcs.equipmentLengths.boltOnDischargeLengthFt.value
        : null
    )
  },
  {
    section: "BOLT ON DISCHARGE",
    label: "Weight",
    targetUnit: targetUnits.massUnit,
    value: computed(() =>
      isBoltOnDischargeMeasurementKnown(
        scenario.equipment.value?.r_bolt_on_discharge?.weight_pounds
      )
        ? calcs.equipmentWeights.boltOnDischargeWeightLbs.value
        : null
    )
  }
];
